<script>
  import FilterDialog2 from "./FilterDialog2.svelte";
  import { translate } from "../../i18n/i18next.js";

  export let filter

  export let items

  export let onFilterChanged

  let isFilterDialogOpen = false

  $: filteredItems = items.filter(item => !item.excluded && item.displayed)
  $: filterLabel = filteredItems.length === 1
    ? filteredItems[0].text
    : translate("frontend:filters.filteredItemsLength", null, {len: filteredItems.length})

  $: isFilterOn = items.filter(item => !item.excluded).length !== items.length

  function onClickClear(e) {
    e.stopPropagation()
    items.forEach(item => item.excluded = false)
    filter.items = items
    onFilterChanged(filter)
  }
</script>

<button class="filter-button" on:click={() => isFilterDialogOpen = true}>
  {#if isFilterOn}
    <img src="/assets/icons/icon_filter_on.svg" alt="filter on icon"/>
    <span class="filter-label-target">
      {#if filter.targetTranslationKey}
        {translate(filter.targetTranslationKey)}:
      {:else}
        {filter.target}:
      {/if}
    </span>
    <span class="filter-label-items">{filterLabel}</span>
    <button on:click={onClickClear}>
      <img src="/assets/icons/icon_close_blue.svg" alt="close icon"/>
    </button>
  {:else}
    <img src="/assets/icons/icon_filter_off.svg" alt="filter off icon"/>
    <span class="filter-label-target">
      {#if filter.targetTranslationKey}
        {translate(filter.targetTranslationKey)}:
      {:else}
        {filter.target}:
      {/if}
    </span>
    <span class="filter-label-items" style="color: darkgrey">
      {translate("frontend:filters.noFilterApplied")}
    </span>
    <button on:click={onClickClear} disabled={true}>
      <img src="/assets/icons/icon_close_gray.svg" alt="close icon"/>
    </button>
  {/if}
</button>
{#if isFilterDialogOpen}
  <FilterDialog2
    target={filter.target}
    targetTranslationKey={filter.targetTranslationKey}
    onFilterDetermined={() => {
      filter.items = items
      onFilterChanged(filter)
      isFilterDialogOpen = false;
    }}
    onClose={() => isFilterDialogOpen = false}
    bind:items={items}
  />
{/if}

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  .filter-button {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    border: 2px solid #00468f;
    border-radius: 5px;
    padding: 4px;
    gap: 4px;
    cursor: pointer;
  }
  .filter-button img {
    vertical-align: baseline;
  }
  .filter-label-target {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
  }
  .filter-label-items {
    text-align: left;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
